import React, { FC } from "react";
import { useFormState } from "react-final-form";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import { IWizardStepContent } from "../../../wizard/types";
import { IGetPrivateClassFrontEndModel } from "../../types";
import UploadFile from "../../../../components/UploadFile/UploadFile";

const useStyles = makeStyles(() => ({
  stepContainer: {
    backgroundColor: "#f5f6f7",
    borderRadius: 12,
    padding: 16,
    "& + &": {
      marginTop: 16,
    },
    "&>div:first-child": {
      marginTop: "unset",
    },
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 32,
  },
  content: {
    fontSize: 16,
    fontWeight: "normal",
    color: "#000",
    marginTop: 8,
    wordBreak: "break-word",
  },
  descriptionContent: {
    "& .table": {
      margin: "0.9em auto",
      display: "table",
    },
    "& .table table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      width: "100%",
      height: "100%",
    },
    "& .table table td": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
    },
    "& .table table th": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
      fontWeight: "bold",
      background: "hsla(0, 0%, 0%, 5%)",
    },
  },
  divider: {
    marginTop: 24,
    color: "#dae1ed",
  },
  fileUploader: {
    marginBottom: -16,
  },
}));

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const { values }: { values: IGetPrivateClassFrontEndModel } = useFormState();
  const classes = useStyles();

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div>
        <div className={classes.stepContainer}>
          <div className={classes.label}>Subject Name</div>
          <div className={classes.content}>{values.subjectName}</div>

          <div className={classes.label}>Teaching Language</div>
          <div className={classes.content}>{values.teachingLanguage}</div>

          <div className={classes.label}>Description</div>
          <div
            dangerouslySetInnerHTML={{ __html: values.description }}
            className={classes.descriptionContent}
          />

          {values.extraFiles && values.extraFiles.length > 0 && (
            <>
              <Divider className={classes.divider} />
              <div className={classes.fileUploader}>
                <UploadFile
                  isViewMode
                  uploadedFiles={values.extraFiles}
                  titleText="Extra Files"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </form>
  );
};

export default Content;
